import { cutDigitFromRight } from '../utils';

export const bullionTypes = ({
  bullionsConfig,
  competitorPrice = null,
  pricePerGram,
  prices,
  configValues,
  manualBullionsConfig,
  changedPreviewProductConfig,
  setProductConfig,
  isBuyback,
}) => {
  const calculateManualPriceWithSideDishes = (productType, weight) => {
    const manualMarginPercentageVar = isBuyback
      ? 'manualBuybackMarginPercentage'
      : 'manualMarginPercentage';

    const cutNumberVar = isBuyback ? 'buybackCutNumber' : 'cutNumber';

    const manualBasePrice = !!String(configValues?.manualBasePrice)?.includes(
      ','
    )
      ? Number(configValues?.manualBasePrice?.replace(/,/g, ''))
      : Number(configValues?.manualBasePrice);

    const manualBasePrice995 = (manualBasePrice / 999) * 995;

    const basePrice = productType.includes('GB_995')
      ? manualBasePrice995
      : manualBasePrice;

    const manualMarginPercentage =
      1 +
      Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === productType)
          ?.[manualMarginPercentageVar]?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === productType)
            ?.[manualMarginPercentageVar]?.toString() ||
          0
      ) /
        100;

    const cutNumber =
      Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === productType)
          ?.[cutNumberVar]?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === productType)
            ?.[cutNumberVar]?.toString()
      ) || 0;
    const calculatedPricewithPercentage = Math.floor(
      basePrice * manualMarginPercentage * weight
    );

    return cutDigitFromRight(calculatedPricewithPercentage, cutNumber);
  };

  const calculateManualBoardPriceWithSideDishes = (productType, weight) => {
    const manualBasePrice = !!String(configValues?.manualBasePrice)?.includes(
      ','
    )
      ? Number(configValues?.manualBasePrice?.replace(/,/g, ''))
      : Number(configValues?.manualBasePrice);

    const manualBasePrice995 = (manualBasePrice / 999) * 995;

    const basePrice = productType.includes('GB_995')
      ? manualBasePrice995
      : manualBasePrice;

    const manualMarginPercentage =
      1 +
      Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === productType)
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === productType)
            ?.manualMarginPercentage?.toString() ||
          0
      ) /
        100;

    const cutNumber =
      Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === productType)
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === productType)
            ?.cutNumber?.toString()
      ) || 0;

    if (manualMarginPercentage < 1 && manualMarginPercentage !== 0) {
      const calculatedPriceWithoutDiscount = Math.floor(basePrice * weight);
      const res = cutDigitFromRight(calculatedPriceWithoutDiscount, cutNumber);
      if (res == calculateManualPriceWithSideDishes(productType, weight)) {
        return -1;
      }
      return res;
    } else if (manualMarginPercentage === 0) {
      return calculateManualPriceWithSideDishes(productType, weight);
    }
    return -1;
  };

  const getprofitPercentage = bullionData => {
    let profitPercentage = null;
    let profitPercentageVariable = null;

    if (bullionData?.strategy === 'MANUAL') {
      profitPercentage = bullionData.manualMarginPercentage;
      profitPercentageVariable = 'manualMarginPercentage';
    } else if (bullionData?.strategy === 'AUTOMATIC_COMPETITOR') {
      profitPercentage = bullionData.differenceWithCompetitorPercentage;
      profitPercentageVariable = 'differenceWithCompetitorPercentage';
    } else if (bullionData?.strategy === 'AUTOMATIC_ESTJT') {
      profitPercentage = bullionData.estjtProfitPercentage;
      profitPercentageVariable = 'estjtProfitPercentage';
    }

    return { profitPercentage, profitPercentageVariable };
  };

  const getBuybackProfitPercentage = bullionData => {
    let profitPercentage = null;
    let profitPercentageVariable = null;

    if (bullionData?.buybackStrategy === 'MANUAL') {
      profitPercentage = bullionData.manualBuybackMarginPercentage;
      profitPercentageVariable = 'manualBuybackMarginPercentage';
    } else if (bullionData?.buybackStrategy === 'AUTOMATIC_ESTJT') {
      profitPercentage = bullionData.estjtBuybackMarginPercentage;
      profitPercentageVariable = 'estjtBuybackMarginPercentage';
    }

    return { profitPercentage, profitPercentageVariable };
  };

  return [
    {
      key: 'GB_999_1',
      name: '۱ گرمی ۹۹۹',
      weight: 1,
      price: prices.GB_999_1.BUY,
      buybackPrice: prices.GB_999_1.BUYBACK,
      boardPrice: prices.GB_999_1.BOARD,
      manualPreviewPrice: calculateManualPriceWithSideDishes('GB_999_1', 1),
      manualPreviewCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_1')
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_1')
            ?.cutNumber?.toString() ||
          0
      ),
      manualPreviewBoardPrice: calculateManualBoardPriceWithSideDishes(
        'GB_999_1',
        1
      ),
      previewManualMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_1')
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_1')
            ?.manualMarginPercentage?.toString() ||
          0
      ),
      previewProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_1', 1) /
          (pricePerGram * 1) -
          1) *
        100
      ).toFixed(2),
      profitMargin: (
        (prices.GB_999_1.BUY / (pricePerGram * 1) - 1) *
        100
      ).toFixed(2),
      buybackProfitMargin: (
        (prices.GB_999_1.BUYBACK / (pricePerGram * 1) - 1) *
        100
      ).toFixed(2),
      competitorData: !!competitorPrice
        ? {
            tokeniko: competitorPrice?.['1']?.tokeniko,
            tokeniko_active: competitorPrice?.['1']?.tokeniko_active,
          }
        : null,
      cutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.cutNumber,
      manualBasePrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_1')
          ?.manualBasePrice || 0,

      profitPercentage: getprofitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_1')
      ).profitPercentage,

      buybackProfitPercentage: getBuybackProfitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_1')
      ).profitPercentage,

      differenceWithCompetitorPercentage:
        bullionsConfig?.find(b => b.productType === 'GB_999_1')
          ?.differenceWithCompetitorPercentage || 0,
      createdBy: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.createdBy?.fullName,
      buybackCreatedBy: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.buybackCreatedBy?.fullName,
      createdAt: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.createdAt,

      buybackCreatedAt: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.buybackCreatedAt,
      strategy: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.strategy,
      costPercentage: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.costPercentage,
      dialogProps: {
        showAlert: false,
        onClick: data => setProductConfig(data, 'GB_999_1'),
      },
      buybackStrategy: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.buybackStrategy,

      buybackCutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_1')
        ?.buybackCutNumber,

      manualBaseBuybackPrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_1')
          ?.manualBaseBuybackPrice || 0,

      previewBuybackProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_1', 1) /
          (pricePerGram * 1) -
          1) *
        100
      ).toFixed(2),

      manualPreviewBuybackPrice: calculateManualPriceWithSideDishes(
        'GB_999_1',
        1
      ),

      manualPreviewBuybackCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_1')
          ?.buybackCutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_1')
            ?.buybackCutNumber?.toString() ||
          0
      ),

      previewManualBuybackMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_1')
          ?.manualBuybackMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_1')
            ?.manualBuybackMarginPercentage?.toString() ||
          0
      ),
    },

    {
      key: 'GB_999_2',
      name: '۲ گرمی ۹۹۹',
      weight: 2,
      previewProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_2', 2) /
          (pricePerGram * 2) -
          1) *
        100
      ).toFixed(2),
      profitMargin: (
        (prices.GB_999_2.BUY / (pricePerGram * 2) - 1) *
        100
      ).toFixed(2),
      buybackProfitMargin: (
        (prices.GB_999_2.BUYBACK / (pricePerGram * 2) - 1) *
        100
      ).toFixed(2),
      manualPreviewPrice: calculateManualPriceWithSideDishes('GB_999_2', 2),
      manualPreviewCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_2')
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_2')
            ?.cutNumber?.toString() ||
          0
      ),
      costPercentage: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.costPercentage,
      manualBasePrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_2')
          ?.manualBasePrice || 0,
      previewManualMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_2')
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_2')
            ?.manualMarginPercentage?.toString() ||
          0
      ),
      competitorData: !!competitorPrice
        ? {
            tokeniko: competitorPrice?.['2']?.tokeniko,
            tokeniko_active: competitorPrice?.['2']?.tokeniko_active,
          }
        : null,
      price: prices.GB_999_2.BUY,
      buybackPrice: prices.GB_999_2.BUYBACK,
      boardPrice: prices.GB_999_2.BOARD,
      cutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.cutNumber,
      manualPreviewBoardPrice: calculateManualBoardPriceWithSideDishes(
        'GB_999_2',
        2
      ),
      createdBy: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.createdBy?.fullName,
      buybackCreatedBy: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.buybackCreatedBy?.fullName,
      createdAt: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.createdAt,

      buybackCreatedAt: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.buybackCreatedAt,
      profitPercentage: getprofitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_2')
      ).profitPercentage,
      buybackProfitPercentage: getBuybackProfitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_2')
      ).profitPercentage,

      differenceWithCompetitorPercentage:
        bullionsConfig?.find(b => b.productType === 'GB_999_2')
          ?.differenceWithCompetitorPercentage || 0,
      strategy: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.strategy,
      dialogProps: {
        showAlert: false,
        onClick: data => setProductConfig(data, 'GB_999_2'),
      },

      buybackStrategy: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.buybackStrategy,

      buybackCutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_2')
        ?.buybackCutNumber,

      manualBaseBuybackPrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_2')
          ?.manualBaseBuybackPrice || 0,

      previewBuybackProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_2', 2) /
          (pricePerGram * 2) -
          1) *
        100
      ).toFixed(2),

      manualPreviewBuybackPrice: calculateManualPriceWithSideDishes(
        'GB_999_2',
        2
      ),

      manualPreviewBuybackCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_2')
          ?.buybackCutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_2')
            ?.buybackCutNumber?.toString() ||
          0
      ),

      previewManualBuybackMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_2')
          ?.manualBuybackMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_2')
            ?.manualBuybackMarginPercentage?.toString() ||
          0
      ),
    },
    {
      key: 'GB_999_5',
      name: ' ۵ گرمی ۹۹۹',
      weight: 5,
      previewProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_5', 5) /
          (pricePerGram * 5) -
          1) *
        100
      ).toFixed(2),
      profitMargin: (
        (prices.GB_999_5.BUY / (pricePerGram * 5) - 1) *
        100
      ).toFixed(2),
      buybackProfitMargin: (
        (prices.GB_999_5.BUYBACK / (pricePerGram * 5) - 1) *
        100
      ).toFixed(2),
      costPercentage: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.costPercentage,
      manualBasePrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_5')
          ?.manualBasePrice || 0,
      createdBy: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.createdBy?.fullName,
      buybackCreatedBy: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.buybackCreatedBy?.fullName,
      createdAt: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.createdAt,

      buybackCreatedAt: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.buybackCreatedAt,
      manualPreviewPrice: calculateManualPriceWithSideDishes('GB_999_5', 5),
      manualPreviewCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_5')
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_5')
            ?.cutNumber?.toString() ||
          0
      ),
      previewManualMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_5')
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_5')
            ?.manualMarginPercentage?.toString() ||
          0
      ),
      manualPreviewBoardPrice: calculateManualBoardPriceWithSideDishes(
        'GB_999_5',
        5
      ),
      competitorData: !!competitorPrice
        ? {
            tokeniko: competitorPrice?.['5']?.tokeniko,
            tokeniko_active: competitorPrice?.['5']?.tokeniko_active,
          }
        : null,
      price: prices.GB_999_5.BUY,
      buybackPrice: prices.GB_999_5.BUYBACK,
      boardPrice: prices.GB_999_5.BOARD,
      cutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.cutNumber,
      profitPercentage: getprofitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_5')
      ).profitPercentage,
      buybackProfitPercentage: getBuybackProfitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_5')
      ).profitPercentage,
      strategy: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.strategy,

      differenceWithCompetitorPercentage:
        bullionsConfig?.find(b => b.productType === 'GB_999_5')
          ?.differenceWithCompetitorPercentage || 0,
      dialogProps: {
        showAlert: false,
        onClick: data => setProductConfig(data, 'GB_999_5'),
      },

      buybackStrategy: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.buybackStrategy,

      buybackCutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_5')
        ?.buybackCutNumber,

      manualBaseBuybackPrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_5')
          ?.manualBaseBuybackPrice || 0,

      previewBuybackProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_5', 5) /
          (pricePerGram * 5) -
          1) *
        100
      ).toFixed(2),

      manualPreviewBuybackPrice: calculateManualPriceWithSideDishes(
        'GB_999_5',
        5
      ),

      manualPreviewBuybackCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_5')
          ?.buybackCutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_5')
            ?.buybackCutNumber?.toString() ||
          0
      ),

      previewManualBuybackMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_5')
          ?.manualBuybackMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_5')
            ?.manualBuybackMarginPercentage?.toString() ||
          0
      ),
    },
    {
      key: 'GB_999_10',
      name: ' ۱۰ گرمی ۹۹۹',
      weight: 10,
      price: prices.GB_999_10.BUY,
      buybackPrice: prices.GB_999_10.BUYBACK,
      boardPrice: prices.GB_999_10.BOARD,
      previewProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_10', 10) /
          (pricePerGram * 10) -
          1) *
        100
      ).toFixed(2),
      profitMargin: (
        (prices.GB_999_10.BUY / (pricePerGram * 10) - 1) *
        100
      ).toFixed(2),
      buybackProfitMargin: (
        (prices.GB_999_10.BUYBACK / (pricePerGram * 10) - 1) *
        100
      ).toFixed(2),
      costPercentage: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.costPercentage,
      manualBasePrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_10')
          ?.manualBasePrice || 0,
      createdBy: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.createdBy?.fullName,
      buybackCreatedBy: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.buybackCreatedBy?.fullName,
      createdAt: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.createdAt,

      buybackCreatedAt: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.buybackCreatedAt,
      competitorData: !!competitorPrice
        ? {
            tokeniko: competitorPrice?.['10']?.tokeniko,
            tokeniko_active: competitorPrice?.['10']?.tokeniko_active,
          }
        : null,
      manualPreviewPrice: calculateManualPriceWithSideDishes('GB_999_10', 10),
      manualPreviewCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_10')
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_10')
            ?.cutNumber?.toString() ||
          0
      ),
      manualPreviewBoardPrice: calculateManualBoardPriceWithSideDishes(
        'GB_999_10',
        10
      ),
      previewManualMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_10')
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_10')
            ?.manualMarginPercentage?.toString() ||
          0
      ),
      cutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.cutNumber,
      profitPercentage: getprofitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_10')
      ).profitPercentage,
      buybackProfitPercentage: getBuybackProfitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_10')
      ).profitPercentage,
      strategy: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.strategy,

      differenceWithCompetitorPercentage:
        bullionsConfig?.find(b => b.productType === 'GB_999_10')
          ?.differenceWithCompetitorPercentage || 0,
      dialogProps: {
        showAlert: false,
        onClick: data => setProductConfig(data, 'GB_999_10'),
      },

      buybackStrategy: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.buybackStrategy,

      buybackCutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_10')
        ?.buybackCutNumber,

      manualBaseBuybackPrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_10')
          ?.manualBaseBuybackPrice || 0,

      previewBuybackProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_10', 10) /
          (pricePerGram * 10) -
          1) *
        100
      ).toFixed(2),

      manualPreviewBuybackPrice: calculateManualPriceWithSideDishes(
        'GB_999_10',
        10
      ),

      manualPreviewBuybackCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_10')
          ?.buybackCutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_10')
            ?.buybackCutNumber?.toString() ||
          0
      ),

      previewManualBuybackMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_10')
          ?.manualBuybackMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_10')
            ?.manualBuybackMarginPercentage?.toString() ||
          0
      ),
    },
    {
      key: 'GB_999_20',
      name: ' ۲۰ گرمی ۹۹۹',
      weight: 20,
      previewProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_20', 20) /
          (pricePerGram * 20) -
          1) *
        100
      ).toFixed(2),
      profitMargin: (
        (prices.GB_999_20.BUY / (pricePerGram * 20) - 1) *
        100
      ).toFixed(2),
      buybackProfitMargin: (
        (prices.GB_999_20.BUYBACK / (pricePerGram * 20) - 1) *
        100
      ).toFixed(2),
      createdBy: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.createdBy?.fullName,
      buybackCreatedBy: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.buybackCreatedBy?.fullName,
      createdAt: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.createdAt,

      buybackCreatedAt: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.buybackCreatedAt,
      competitorData: !!competitorPrice
        ? {
            tokeniko: competitorPrice?.['20']?.tokeniko,
            tokeniko_active: competitorPrice?.['20']?.tokeniko_active,
          }
        : null,
      manualBasePrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_20')
          ?.manualBasePrice || 0,
      manualPreviewPrice: calculateManualPriceWithSideDishes('GB_999_20', 20),
      manualPreviewCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_20')
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_20')
            ?.cutNumber?.toString() ||
          0
      ),
      costPercentage: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.costPercentage,
      manualPreviewBoardPrice: calculateManualBoardPriceWithSideDishes(
        'GB_999_20',
        20
      ),
      previewManualMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_20')
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_20')
            ?.manualMarginPercentage?.toString() ||
          0
      ),
      price: prices.GB_999_20.BUY,
      buybackPrice: prices.GB_999_20.BUYBACK,
      boardPrice: prices.GB_999_20.BOARD,
      cutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.cutNumber,
      profitPercentage: getprofitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_20')
      ).profitPercentage,
      buybackProfitPercentage: getBuybackProfitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_20')
      ).profitPercentage,
      strategy: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.strategy,

      differenceWithCompetitorPercentage:
        bullionsConfig?.find(b => b.productType === 'GB_999_20')
          ?.differenceWithCompetitorPercentage || 0,
      dialogProps: {
        showAlert: false,
        onClick: data => setProductConfig(data, 'GB_999_20'),
      },

      buybackStrategy: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.buybackStrategy,

      buybackCutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_20')
        ?.buybackCutNumber,

      manualBaseBuybackPrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_20')
          ?.manualBaseBuybackPrice || 0,

      previewBuybackProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_20', 20) /
          (pricePerGram * 20) -
          1) *
        100
      ).toFixed(2),

      manualPreviewBuybackPrice: calculateManualPriceWithSideDishes(
        'GB_999_20',
        20
      ),

      manualPreviewBuybackCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_20')
          ?.buybackCutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_20')
            ?.buybackCutNumber?.toString() ||
          0
      ),

      previewManualBuybackMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_20')
          ?.manualBuybackMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_20')
            ?.manualBuybackMarginPercentage?.toString() ||
          0
      ),
    },
    {
      key: 'GB_999_50',
      name: ' ۵۰ گرمی ۹۹۹',
      weight: 50,
      price: prices.GB_999_50.BUY,
      buybackPrice: prices.GB_999_50.BUYBACK,
      boardPrice: prices.GB_999_50.BOARD,
      previewProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_50', 50) /
          (pricePerGram * 50) -
          1) *
        100
      ).toFixed(2),
      createdBy: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.createdBy?.fullName,
      buybackCreatedBy: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.buybackCreatedBy?.fullName,
      createdAt: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.createdAt,

      buybackCreatedAt: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.buybackCreatedAt,
      profitMargin: (
        (prices.GB_999_50.BUY / (pricePerGram * 50) - 1) *
        100
      ).toFixed(2),
      buybackProfitMargin: (
        (prices.GB_999_50.BUYBACK / (pricePerGram * 50) - 1) *
        100
      ).toFixed(2),
      costPercentage: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.costPercentage,
      competitorData: !!competitorPrice
        ? {
            tokeniko: competitorPrice?.['50']?.tokeniko,
            tokeniko_active: competitorPrice?.['50']?.tokeniko_active,
          }
        : null,
      manualBasePrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_50')
          ?.manualBasePrice || 0,
      manualPreviewPrice: calculateManualPriceWithSideDishes('GB_999_50', 50),
      manualPreviewCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_50')
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_50')
            ?.cutNumber?.toString() ||
          0
      ),
      manualPreviewBoardPrice: calculateManualBoardPriceWithSideDishes(
        'GB_999_50',
        50
      ),
      previewManualMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_50')
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_50')
            ?.manualMarginPercentage?.toString() ||
          0
      ),
      profitPercentage: getprofitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_50')
      ).profitPercentage,

      buybackProfitPercentage: getBuybackProfitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_50')
      ).profitPercentage,
      differenceWithCompetitorPercentage:
        bullionsConfig?.find(b => b.productType === 'GB_999_50')
          ?.differenceWithCompetitorPercentage || 0,
      cutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.cutNumber,
      strategy: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.strategy,
      dialogProps: {
        showAlert: false,
        onClick: data => setProductConfig(data, 'GB_999_50'),
      },

      buybackStrategy: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.buybackStrategy,

      buybackCutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_50')
        ?.buybackCutNumber,

      manualBaseBuybackPrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_50')
          ?.manualBaseBuybackPrice || 0,

      previewBuybackProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_50', 50) /
          (pricePerGram * 50) -
          1) *
        100
      ).toFixed(2),

      manualPreviewBuybackPrice: calculateManualPriceWithSideDishes(
        'GB_999_50',
        50
      ),

      manualPreviewBuybackCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_50')
          ?.buybackCutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_50')
            ?.buybackCutNumber?.toString() ||
          0
      ),

      previewManualBuybackMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_50')
          ?.manualBuybackMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_50')
            ?.manualBuybackMarginPercentage?.toString() ||
          0
      ),
    },
    {
      key: 'GB_999_100',
      name: ' ۱۰۰ گرمی ۹۹۹',
      weight: 100,
      profitMargin: (
        (prices.GB_999_100.BUY / (pricePerGram * 100) - 1) *
        100
      ).toFixed(2),
      buybackProfitMargin: (
        (prices.GB_999_100.BUYBACK / (pricePerGram * 100) - 1) *
        100
      ).toFixed(2),
      createdBy: bullionsConfig?.find(b => b.productType === 'GB_999_100')
        ?.createdBy?.fullName,
      buybackCreatedBy: bullionsConfig?.find(
        b => b.productType === 'GB_999_100'
      )?.buybackCreatedBy?.fullName,
      createdAt: bullionsConfig?.find(b => b.productType === 'GB_999_100')
        ?.createdAt,

      buybackCreatedAt: bullionsConfig?.find(
        b => b.productType === 'GB_999_100'
      )?.buybackCreatedAt,
      previewProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_100', 100) /
          (pricePerGram * 100) -
          1) *
        100
      ).toFixed(2),
      competitorData: !!competitorPrice
        ? {
            tokeniko: competitorPrice?.['100']?.tokeniko,
            tokeniko_active: competitorPrice?.['100']?.tokeniko_active,
          }
        : null,
      manualBasePrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_100')
          ?.manualBasePrice || 0,
      differenceWithCompetitorPercentage:
        bullionsConfig?.find(b => b.productType === 'GB_999_100')
          ?.differenceWithCompetitorPercentage || 0,
      manualPreviewPrice: calculateManualPriceWithSideDishes('GB_999_100', 100),
      manualPreviewCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_100')
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_100')
            ?.cutNumber?.toString() ||
          0
      ),
      manualPreviewBoardPrice: calculateManualBoardPriceWithSideDishes(
        'GB_999_100',
        100
      ),
      costPercentage: bullionsConfig?.find(b => b.productType === 'GB_999_100')
        ?.costPercentage,
      previewManualMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_100')
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_100')
            ?.manualMarginPercentage?.toString() ||
          0
      ),
      price: prices.GB_999_100.BUY,
      buybackPrice: prices.GB_999_100.BUYBACK,
      boardPrice: prices.GB_999_100.BOARD,
      cutNumber: bullionsConfig?.find(b => b.productType === 'GB_999_100')
        ?.cutNumber,
      profitPercentage: getprofitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_100')
      ).profitPercentage,
      buybackProfitPercentage: getBuybackProfitPercentage(
        bullionsConfig?.find(b => b.productType === 'GB_999_100')
      ).profitPercentage,
      strategy: bullionsConfig?.find(b => b.productType === 'GB_999_100')
        ?.strategy,
      dialogProps: {
        showAlert: false,
        onClick: data => setProductConfig(data, 'GB_999_100'),
      },

      buybackStrategy: bullionsConfig?.find(b => b.productType === 'GB_999_100')
        ?.buybackStrategy,

      buybackCutNumber: bullionsConfig?.find(
        b => b.productType === 'GB_999_100'
      )?.buybackCutNumber,

      manualBaseBuybackPrice:
        bullionsConfig?.find(b => b.productType === 'GB_999_100')
          ?.manualBaseBuybackPrice || 0,

      previewBuybackProfitMargin: (
        (calculateManualPriceWithSideDishes('GB_999_100', 100) /
          (pricePerGram * 100) -
          1) *
        100
      ).toFixed(2),

      manualPreviewBuybackPrice: calculateManualPriceWithSideDishes(
        'GB_999_100',
        100
      ),

      manualPreviewBuybackCutNumber: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_100')
          ?.buybackCutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_100')
            ?.buybackCutNumber?.toString() ||
          0
      ),

      previewManualBuybackMarginPercentage: Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === 'GB_999_100')
          ?.manualBuybackMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === 'GB_999_100')
            ?.manualBuybackMarginPercentage?.toString() ||
          0
      ),
    },

    // {
    //   key: 'GB_995_1',
    //   name: '۱ گرمی ۹۹۵',
    //   weight: 1,
    //   price: prices.GB_995_1,
    //   manualPreviewPrice: calculateManualPriceWithSideDishes('GB_995_1', 1),
    //   manualPreviewCutNumber: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_1')
    //       ?.cutNumber?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_1')
    //         ?.cutNumber?.toString() ||
    //       0
    //   ),
    //   previewManualMarginPercentage: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_1')
    //       ?.manualMarginPercentage?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_1')
    //         ?.manualMarginPercentage?.toString() ||
    //       0
    //   ),
    //   previewProfitMargin: (
    //     (calculateManualPriceWithSideDishes('GB_995_1', 1) /
    //       (pricePerGram * 1) -
    //       1) *
    //     100
    //   ).toFixed(2),
    //   profitMargin: ((prices.GB_995_1 / (pricePerGram * 1) - 1) * 100).toFixed(
    //     2
    //   ),
    //   competitorData:!!competitorPrice? {
    //     tokeniko: competitorPrice?.['1']?.tokeniko,
    //     tokeniko_active: competitorPrice?.['1']?.tokeniko_active,
    //   }:null,
    //   cutNumber: bullionsConfig?.find(b => b.productType === 'GB_995_1')
    //     ?.cutNumber,
    //   profitPercentage: getprofitPercentage(
    //     bullionsConfig?.find(b => b.productType === 'GB_995_1')
    //   ).profitPercentage,
    //   strategy: bullionsConfig?.find(b => b.productType === 'GB_995_1')
    //     ?.strategy,
    //   dialogProps: {
    //     lastPrice: prices.GB_995_1,
    //     showAlert: false,
    //     label: 'درصد',
    //     onClick: data => setProductConfig(data, 'GB_995_1'),
    //   },
    // },
    // {
    //   key: 'GB_995_2',
    //   name: '۲ گرمی ۹۹۵ ',
    //   weight: 2,
    //   previewProfitMargin: (
    //     (calculateManualPriceWithSideDishes('GB_995_2', 2) /
    //       (pricePerGram * 2) -
    //       1) *
    //     100
    //   ).toFixed(2),
    //   profitMargin: ((prices.GB_995_2 / (pricePerGram * 2) - 1) * 100).toFixed(
    //     2
    //   ),
    //   manualPreviewPrice: calculateManualPriceWithSideDishes('GB_995_2', 2),
    //   manualPreviewCutNumber: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_2')
    //       ?.cutNumber?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_2')
    //         ?.cutNumber?.toString() ||
    //       0
    //   ),
    //   previewManualMarginPercentage: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_2')
    //       ?.manualMarginPercentage?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_2')
    //         ?.manualMarginPercentage?.toString() ||
    //       0
    //   ),
    //   competitorData: !!competitorPrice?{
    //     tokeniko: competitorPrice?.['2']?.tokeniko,
    //     tokeniko_active: competitorPrice?.['2']?.tokeniko_active,
    //   }:null,
    //   price: prices.GB_995_2,
    //   cutNumber: bullionsConfig?.find(b => b.productType === 'GB_995_2')
    //     ?.cutNumber,
    //   profitPercentage: getprofitPercentage(
    //     bullionsConfig?.find(b => b.productType === 'GB_995_2')
    //   ).profitPercentage,
    //   strategy: bullionsConfig?.find(b => b.productType === 'GB_995_2')
    //     ?.strategy,
    //   dialogProps: {
    //     lastPrice: prices.GB_995_2,
    //     showAlert: false,
    //     label: 'درصد',
    //     onClick: data => setProductConfig(data, 'GB_995_2'),
    //   },
    // },
    // {
    //   key: 'GB_995_5',
    //   name: ' ۵ گرمی ۹۹۵',
    //   weight: 5,
    //   previewProfitMargin: (
    //     (calculateManualPriceWithSideDishes('GB_995_5', 5) /
    //       (pricePerGram * 5) -
    //       1) *
    //     100
    //   ).toFixed(2),
    //   profitMargin: ((prices.GB_995_5 / (pricePerGram * 5) - 1) * 100).toFixed(
    //     2
    //   ),
    //   manualPreviewPrice: calculateManualPriceWithSideDishes('GB_995_5', 5),
    //   manualPreviewCutNumber: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_5')
    //       ?.cutNumber?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_5')
    //         ?.cutNumber?.toString() ||
    //       0
    //   ),
    //   previewManualMarginPercentage: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_5')
    //       ?.manualMarginPercentage?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_5')
    //         ?.manualMarginPercentage?.toString() ||
    //       0
    //   ),
    //   competitorData: !!competitorPrice?{
    //     tokeniko: competitorPrice?.['5']?.tokeniko,
    //     tokeniko_active: competitorPrice?.['5']?.tokeniko_active,
    //   }:null,
    //   price: prices.GB_995_5,
    //   cutNumber: bullionsConfig?.find(b => b.productType === 'GB_995_5')
    //     ?.cutNumber,
    //   profitPercentage: getprofitPercentage(
    //     bullionsConfig?.find(b => b.productType === 'GB_995_5')
    //   ).profitPercentage,
    //   strategy: bullionsConfig?.find(b => b.productType === 'GB_995_5')
    //     ?.strategy,
    //   dialogProps: {
    //     lastPrice: prices.GB_995_5,
    //     showAlert: false,
    //     label: 'درصد',
    //     onClick: data => {
    //       console.log('theeeeeeeeeeeeeeeeeeee', data);
    //       return setProductConfig(data, 'GB_995_5');
    //     },
    //   },
    // },
    // {
    //   key: 'GB_995_10',
    //   name: '۱۰ گرمی ۹۹۵',
    //   weight: 10,
    //   price: prices.GB_995_10,
    //   previewProfitMargin: (
    //     (calculateManualPriceWithSideDishes('GB_995_10', 10) /
    //       (pricePerGram * 10) -
    //       1) *
    //     100
    //   ).toFixed(2),
    //   profitMargin: (
    //     (prices.GB_995_10 / (pricePerGram * 10) - 1) *
    //     100
    //   ).toFixed(2),
    //   competitorData:!!competitorPrice? {
    //     tokeniko: competitorPrice?.['10']?.tokeniko,
    //     tokeniko_active: competitorPrice?.['10']?.tokeniko_active,
    //   }:null,
    //   manualPreviewPrice: calculateManualPriceWithSideDishes('GB_995_10', 10),
    //   manualPreviewCutNumber: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_10')
    //       ?.cutNumber?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_10')
    //         ?.cutNumber?.toString() ||
    //       0
    //   ),
    //   previewManualMarginPercentage: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_10')
    //       ?.manualMarginPercentage?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_10')
    //         ?.manualMarginPercentage?.toString() ||
    //       0
    //   ),
    //   cutNumber: bullionsConfig?.find(b => b.productType === 'GB_995_10')
    //     ?.cutNumber,
    //   profitPercentage: getprofitPercentage(
    //     bullionsConfig?.find(b => b.productType === 'GB_995_10')
    //   ).profitPercentage,
    //   strategy: bullionsConfig?.find(b => b.productType === 'GB_995_10')
    //     ?.strategy,
    //   dialogProps: {
    //     lastPrice: prices.GB_995_10,
    //     showAlert: false,
    //     label: 'درصد',
    //     onClick: data => setProductConfig(data, 'GB_995_10'),
    //   },
    // },
    // {
    //   key: 'GB_995_20',
    //   name: '۲۰ گرمی ۹۹۵',
    //   weight: 20,
    //   previewProfitMargin: (
    //     (calculateManualPriceWithSideDishes('GB_995_20', 20) /
    //       (pricePerGram * 20) -
    //       1) *
    //     100
    //   ).toFixed(2),
    //   profitMargin: (
    //     (prices.GB_995_20 / (pricePerGram * 20) - 1) *
    //     100
    //   ).toFixed(2),
    //   competitorData: !!competitorPrice?{
    //     tokeniko: competitorPrice?.['20']?.tokeniko,
    //     tokeniko_active: competitorPrice?.['20']?.tokeniko_active,
    //   }:null,
    //   manualPreviewPrice: calculateManualPriceWithSideDishes('GB_995_20', 20),
    //   manualPreviewCutNumber: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_20')
    //       ?.cutNumber?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_20')
    //         ?.cutNumber?.toString() ||
    //       0
    //   ),
    //   previewManualMarginPercentage: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_20')
    //       ?.manualMarginPercentage?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_20')
    //         ?.manualMarginPercentage?.toString() ||
    //       0
    //   ),
    //   price: prices.GB_995_20,
    //   cutNumber: bullionsConfig?.find(b => b.productType === 'GB_995_20')
    //     ?.cutNumber,
    //   profitPercentage: getprofitPercentage(
    //     bullionsConfig?.find(b => b.productType === 'GB_995_20')
    //   ).profitPercentage,
    //   strategy: bullionsConfig?.find(b => b.productType === 'GB_995_20')
    //     ?.strategy,
    //   dialogProps: {
    //     lastPrice: prices.GB_995_20,
    //     showAlert: false,
    //     label: 'درصد',
    //     onClick: data => setProductConfig(data, 'GB_995_20'),
    //   },
    // },
    // {
    //   key: 'GB_995_50',
    //   name: '۵۰ گرمی ۹۹۵',
    //   weight: 50,
    //   price: prices.GB_995_50,
    //   previewProfitMargin: (
    //     (calculateManualPriceWithSideDishes('GB_995_50', 50) /
    //       (pricePerGram * 50) -
    //       1) *
    //     100
    //   ).toFixed(2),
    //   profitMargin: (
    //     (prices.GB_995_50 / (pricePerGram * 50) - 1) *
    //     100
    //   ).toFixed(2),
    //   competitorData:!!competitorPrice? {
    //     tokeniko: competitorPrice?.['50']?.tokeniko,
    //     tokeniko_active: competitorPrice?.['50']?.tokeniko_active,
    //   }:null,
    //   manualPreviewPrice: calculateManualPriceWithSideDishes('GB_995_50', 50),
    //   manualPreviewCutNumber: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_50')
    //       ?.cutNumber?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_50')
    //         ?.cutNumber?.toString() ||
    //       0
    //   ),
    //   previewManualMarginPercentage: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_50')
    //       ?.manualMarginPercentage?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_50')
    //         ?.manualMarginPercentage?.toString() ||
    //       0
    //   ),
    //   profitPercentage: getprofitPercentage(
    //     bullionsConfig?.find(b => b.productType === 'GB_995_50')
    //   ).profitPercentage,
    //   cutNumber: bullionsConfig?.find(b => b.productType === 'GB_995_50')
    //     ?.cutNumber,
    //   strategy: bullionsConfig?.find(b => b.productType === 'GB_995_50')
    //     ?.strategy,
    //   dialogProps: {
    //     lastPrice: prices.GB_995_50,
    //     showAlert: false,
    //     label: 'درصد',
    //     onClick: data => setProductConfig(data, 'GB_995_50'),
    //   },
    // },
    // {
    //   key: 'GB_995_100',
    //   name: '۱۰۰ گرمی ۹۹۵',
    //   weight: 100,
    //   profitMargin: (
    //     (prices.GB_995_100 / (pricePerGram * 100) - 1) *
    //     100
    //   ).toFixed(2),
    //   previewProfitMargin: (
    //     (calculateManualPriceWithSideDishes('GB_995_100', 100) /
    //       (pricePerGram * 100) -
    //       1) *
    //     100
    //   ).toFixed(2),
    //   competitorData:!!competitorPrice? {
    //     tokeniko: competitorPrice?.['100']?.tokeniko,
    //     tokeniko_active: competitorPrice?.['100']?.tokeniko_active,
    //   }:null,
    //   manualPreviewPrice: calculateManualPriceWithSideDishes('GB_995_100', 100),
    //   manualPreviewCutNumber: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_100')
    //       ?.cutNumber?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_100')
    //         ?.cutNumber?.toString() ||
    //       0
    //   ),
    //   previewManualMarginPercentage: Number(
    //     changedPreviewProductConfig
    //       ?.find(product => product?.productType === 'GB_995_100')
    //       ?.manualMarginPercentage?.toString() ||
    //       manualBullionsConfig
    //         ?.find(b => b.productType === 'GB_995_100')
    //         ?.manualMarginPercentage?.toString() ||
    //       0
    //   ),
    //   price: prices.GB_995_100,
    //   cutNumber: bullionsConfig?.find(b => b.productType === 'GB_995_100')
    //     ?.cutNumber,
    //   profitPercentage: getprofitPercentage(
    //     bullionsConfig?.find(b => b.productType === 'GB_995_100')
    //   ).profitPercentage,
    //   strategy: bullionsConfig?.find(b => b.productType === 'GB_995_100')
    //     ?.strategy,
    //   dialogProps: {
    //     lastPrice: prices.GB_995_100,
    //     showAlert: false,
    //     label: 'درصد',
    //     onClick: data => setProductConfig(data, 'GB_995_100'),
    //   },
    // },
  ];
};
